// Loon history dialog component for the library page

import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import LoonHistoryTable from '../loons/LoonHistoryTable';
import type { LibraryDialogOutletProps } from './dialogOutletTypes';

const LoonHistoryDialog: React.FC<LibraryDialogOutletProps> = ({
  user,
  dialog,
  setDialog,
}) => {
  if (!user) {
    return null;
  }

  return (
    <Dialog
      open={dialog === 'loon-history'}
      onOpenChange={(nextOpen) => setDialog(nextOpen ? 'loon-history' : null)}
    >
      <DialogContent className="w-[calc(100vw-1.5rem)] max-h-[85vh] max-w-[calc(100vw-1.5rem)] grid-rows-[auto_minmax(0,1fr)] gap-0 overflow-hidden p-0 sm:w-fit sm:max-w-[min(100vw-3rem,44rem)]">
        <DialogHeader className="border-b px-6 py-5 pr-14">
          <DialogTitle>Loon History</DialogTitle>
          <DialogDescription>
            Full transaction history for your Loon activity.
          </DialogDescription>
        </DialogHeader>
        <div className="min-h-0 overflow-hidden px-6 py-5">
          <LoonHistoryTable refreshKey={user.loonBalance} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LoonHistoryDialog;
